<template>
  <div>
    <PremiumLoader v-if="loading" @loading-complete="handleLoadingComplete" />
    <section class="plan-details" v-else-if="!error && planDetails">
      <div class="container" style="padding-top: 80px">
        <PlanPricingHeader :planDetails="planDetails" />
        <div class="plan-grid">
          <PlanFeatureCard
            v-if="planDetails.includes?.length"
            title="What's Included"
            :features="planDetails.includes_details"
            card-type="includes"
            delay="100"
          />
          <PlanFeatureCard
            v-if="planDetails.excludes?.length"
            title="Add - on - Services (extra charge)"
            :features="planDetails.add_ons_on_payment"
            card-type="excludes"
            delay="200"
          />
        </div>
      </div>

      <v-layout wrap justify-center class="inspection-section">
        <v-flex xs12 md8 lg6 item-center text-center>
          <div style="padding-bottom: 20px; padding-top: 20px">
            <span
              style="text-transform: uppercase; font-size: 24px; color: #f46523; font-weight: bold"
              class="items-center text-center"
            >
              Free Home Inspection Report
            </span>
          </div>
          <!-- INSPECTION CARD -->
          <v-card elevation="8" class="inspection-card">
            <!-- IMAGE WITH TICK OVERLAY -->
            <div class="inspection-image-wrapper">
              <v-img
                src="@/assets/images/inspection.png"
                alt="Inspection"
                contain
                class="inspection-img-small"
              ></v-img>

              <!-- GREEN TICK -->
              <div class="tick-badge">✓</div>
            </div>

            <!-- TEXT CONTENT -->
            <v-card-text class="inspection-card-text">
              Gain awareness of potential issues lurking behind your walls. Our
              <strong>Free Home Inspection Report</strong> provides valuable insights into your
              home's health, helping you mitigate future complaints.
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>

      <div class="floating-proceed-btn">
        <AnimatedProceedButton
          @click="
            $router.push({
              name: 'PackageForm',
              params: { planId },
              query: { includes: JSON.stringify(includesDetails) },
            })
          "
        />
      </div>

      <a
        href="https://wa.me/917034444303"
        target="_blank"
        class="floating-whatsapp"
        aria-label="WhatsApp Enquiry"
      >
        <img src="https://cdn-icons-png.flaticon.com/512/124/124034.png" alt="WhatsApp" />
        <span class="whatsapp-text">+91 735 6449 135</span>
      </a>

      <div class="bg-decorations">
        <div class="bg-circle bc1"></div>
        <div class="bg-triangle bt1"></div>
      </div>

      <svg width="0" height="0" style="position: absolute">
        <defs>
          <linearGradient id="includeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color: #10b981; stop-opacity: 1" />
            <stop offset="100%" style="stop-color: #059669; stop-opacity: 1" />
          </linearGradient>
          <linearGradient id="excludeGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style="stop-color: #ef4444; stop-opacity: 1" />
            <stop offset="100%" style="stop-color: #dc2626; stop-opacity: 1" />
          </linearGradient>
        </defs>
      </svg>
    </section>

    <div v-else-if="error" class="error-state">
      <h2>Unable to load plan details</h2>
      <button @click="loadPlanData">Try Again</button>
    </div>
  </div>
</template>

<script>
import { getPackageDetail } from '@/services/planService';
import PremiumLoader from '@/components/PremiumLoader.vue';
import PlanPricingHeader from '@/components/PlanPricingHeader.vue';
import PlanFeatureCard from '@/components/PlanFeatureCard.vue';
import AnimatedProceedButton from '@/components/AnimatedProceedButton.vue';

export default {
  name: 'PlanDetailedView',
  props: ['id'],
  components: {
    PremiumLoader,
    PlanPricingHeader,
    PlanFeatureCard,
    AnimatedProceedButton,
  },
  data() {
    return {
      planId: this.id,
      planDetails: null,
      loading: true,
      includesDetails: null,
      error: false,
      dataLoaded: false,
    };
  },
  async mounted() {
    this.loadPlanData();
  },
  methods: {
    async loadPlanData() {
      this.loading = true;
      this.error = false;
      this.dataLoaded = false;

      try {
        const response = await getPackageDetail(this.planId);
        this.planDetails = response?.data?.plans || response?.data || null;
        if (!this.planDetails) {
          throw new Error('No plan data received');
        }

        const includesArray = (this.planDetails?.includes_details || [])
          .filter((item) => item && item.includes_services)
          .map((item) => item.includes_services);

        this.includesDetails = includesArray;
        console.log('this.includesDetails:', this.includesDetails);
        this.services = includesArray;
        this.dataLoaded = true;
        await new Promise((resolve) => setTimeout(resolve, 1000));
      } catch (err) {
        console.error('Error loading plan:', err);
        this.error = true;
        this.planDetails = null;
      } finally {
        if (this.dataLoaded || this.error) {
          this.loading = false;
        }
      }
    },
    handleLoadingComplete() {
      if (this.dataLoaded || this.error) {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
@import 'https://cdnjs.cloudflare.com/ajax/libs/animate.css/4.1.1/animate.min.css';
@import url('https://fonts.googleapis.com/css2?family=Nunito+Sans:wght@400;600;700;900&display=swap');
.plan-details {
  font-family: 'Nunito Sans', sans-serif;
  padding: 60px 0 80px;
 padding-bottom: 50px; 
  background: white;
  position: relative;
  overflow: hidden;
}

@media (max-width: 768px) {
  .plan-details {
    padding-bottom: 40px;
  }
}



.container {
  max-width: 1100px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

.error-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 70vh;
  font-family: 'Nunito Sans', sans-serif;
  color: #64748b;
}

.error-state h2 {
  margin-bottom: 20px;
  color: #475569;
}

.error-state button {
  background: linear-gradient(135deg, #f46523, #ff9800);
  color: white;
  padding: 12px 24px;
  border-radius: 8px;
  border: none;
  font-weight: 600;
  cursor: pointer;
  transition: transform 0.2s ease;
}

.error-state button:hover {
  transform: translateY(-2px);
}

.plan-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(320px, 1fr));
  gap: 24px;
  margin-bottom: 40px;
}

.inspection-text {
  display: flex;
  text-align: center;
}

.inspection-section {
  margin-top: 20px;
  margin-bottom: 10px;
  padding: 0 24px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-content: center;
  position: relative;
  z-index: 1;
}

.inspection-img {
  max-width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

.floating-proceed-btn {
  padding-top: 40px;
  left: 50%;
  pointer-events: auto;
}



.floating-whatsapp {
  position: fixed !important;
  bottom: 30px !important;
  right: 30px !important;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #25d366;
  color: white;
  padding: 10px 18px;
  border-radius: 50px;
  text-decoration: none;
  font-weight: 600;
  font-family: 'Nunito Sans', sans-serif;
  box-shadow: 0 6px 20px rgba(37, 211, 102, 0.4);
  transition: all 0.3s ease;
  z-index: 99999 !important;
  animation: fadeInUp 0.8s ease;
  pointer-events: auto;
}

.floating-whatsapp img {
  width: 26px;
  height: 26px;
}

.whatsapp-text {
  display: none !important;
}

.floating-whatsapp:hover {
  background: #1ebd5a;
  transform: scale(1.05);
  box-shadow: 0 10px 25px rgba(37, 211, 102, 0.6);
}

@media (max-width: 768px) {
  .floating-proceed-btn {
    bottom: 20px;
  }

  .floating-whatsapp {
    bottom: 20px !important;
    right: 20px !important;
    padding: 8px 14px;
    font-size: 0.85rem;
  }

  .floating-whatsapp img {
    width: 22px;
    height: 22px;
  }

  .whatsapp-text {
    display: none;
  }

  .inspection-section {
    margin-top: 15px;
    margin-bottom: 80px;
  }

  .plan-grid {
    grid-template-columns: 1fr;
  }
}

.bg-decorations {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
}

.bg-circle {
  position: absolute;
  border-radius: 50%;
  width: 80px;
  height: 80px;
  background: rgba(244, 101, 35, 0.05);
  animation: float 10s ease-in-out infinite;
}

.bc1 {
  top: 20%;
  right: 10%;
}

.bg-triangle {
  position: absolute;
  border-left: 60px solid transparent;
  border-right: 60px solid transparent;
  border-bottom: 100px solid rgba(244, 101, 35, 0.04);
  animation: float 12s ease-in-out infinite;
}

.bt1 {
  bottom: 15%;
  left: 5%;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

@keyframes fadeInUp {
  from {
    transform: translateY(40px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

@keyframes float {
  0%,
  100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-12px);
  }
}
.inspection-card {
  max-width: 520px;
  margin: 0 auto;
  border-radius: 16px;
  padding: 20px;
  text-align: center;
}

.inspection-image-wrapper {
  position: relative;
  display: flex;
  justify-content: center;
  margin-bottom: 16px;
}

.inspection-img-small {
  max-width: 320px;
  border-radius: 12px;
}

/* GREEN TICK BADGE */
.tick-badge {
  position: absolute;
  top: -10px;
  right: 40px;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #10b981, #059669);
  color: white;
  font-size: 20px;
  font-weight: bold;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 14px rgba(16, 185, 129, 0.4);
}

.inspection-card-text {
  font-size: 15px;
  line-height: 1.6;
  color: #334155;
}

</style>
